<template>
  <div class="card">
    <div class="card__img">
      <img v-if="card?.type === 'avito'" src="@/assets/images/icons/avito.svg" />
      <img style="width: 48px; height: 48px" v-if="card?.type !== 'avito'" src="@/assets/images/icons/hh.svg" />
    </div>
    <div class="card__content">
        <div class="card__info">
          <h3 class="card__name">{{ card?.name? card?.name : 'Нет названия' }}</h3>
          <div v-if="!card?.avito?.not_correct_webhook" class="card__id">ID: {{ card?.avito?.client_id || card?.id }}</div>

          <div class="card__error-connect flex gap-2" v-if="card?.avito?.not_correct_webhook">
            Сбой подключения
            <div class="link-text card__connect" @click="emit('updateKey', card)">Подключить</div>
          </div>
        </div>
    </div>
    <div v-if="card?.type === 'avito'" class="card__edit" @click="emit('editIntegrationsOpenModal', card?.avito?.client_id, card?.name, card?.avito?.client_secret, card?.id)">
      <Pencil />
    </div>
    <div v-if="card?.type !== 'avito'" class="card__edit" @click="emit('delete', card?.id)">
      <Trash />
    </div>



<!--    v-if="role === 'ADMIN'" :to="`/employees/edit/${card?.id}`"-->
<!--    <router-link class="card__edit" v-if="role === 'SUPER_ADMIN'"-->
<!--        :to="`/companies/${companyId}/edit/${card?.id}`">-->
<!--    <Pencil icon-color="black" />-->
<!--    </router-link>-->
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import Pencil from "@/components/Icons/Pencil.vue";
import Trash from "@/components/Icons/Trash.vue";

const store = useStore();
const emit = defineEmits(['editIntegrationsOpenModal', 'updateKey', 'delete']);

const role = store.getters["auth/role"];

defineProps({
  card: {
      type: Object,
      required: true
  },
  companyId: Number,
  updateKeyList: Array,
})
</script>

<style scoped lang="scss">
.card {
  padding: 16px;
  border-radius: 16px;
  height: 91px;
  display: flex;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0 #0000000A;
  transition: .3s;

  &_blocked {
      box-shadow: none;
      cursor: no-drop;
  }

  &__edit {
    padding: 2px;
    height: 28px;
    margin-left: auto;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $light-gray-1;
    cursor: pointer;
    opacity: 0;
    transition: .3s;



    &:active {
      background-color: $light-gray-2;
    }
  }

  &:hover {
      box-shadow: 2px 2px 24px 0px #1E39591F;
  }

  &_blocked:hover {
      box-shadow: none !important;
  }

  &:hover &__edit {
      opacity: 1;
  }

  &__content {
      display: flex;
  }

  &_blocked &__content {
      opacity: 0.3;
  }

  &__ava {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
  }

  &__info {
    margin-left: 12px;
  }

  &__name {
    margin-top: 2px;
    font-size: 14px;
    font-weight: 600;
  }

  &__subtitle {
    margin-top: 8px;
    color: $gray;
    font-size: 12px;
    font-weight: 500;
  }

  &__email {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 400;
  }

  &__id {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    color: $gray;;
  }

  &__error-connect {
    color: $red;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0;
  }

  &__connect {
    color: $primary-main;
    cursor: pointer;
  }
}
</style>
